import { createStore } from 'redux';
import { combineReducers } from 'redux';
import { geoReducer } from './geo/reducer';
import { boringReducer } from './boring/reducer';
import { modelAreaReducer } from './modelArea/reducer';
import { lrnReducer } from './lrn/reducer';
import { csLineReducer } from './csLine/reducer';
import { csDspReducer } from './csDsp/reducer';
import { plReducer } from './pl/reducer';
import { rsltPlReducer } from './rsltPl/reducer';
import { editerReducer } from './editer/reducer';
import { paramReducer } from './param/reducer';
import { appReducer } from './app/reducer';
import { uiReducer } from './ui/reducer';
import { userReducer } from './user/reducer';
import { wellReducer } from './well/reducer';

const reducer = combineReducers({
    geoReducer,
    boringReducer,
    modelAreaReducer,
    lrnReducer,
    csLineReducer,
    csDspReducer,
    plReducer,
    rsltPlReducer,
    editerReducer,
    paramReducer,
    appReducer,
    uiReducer,
    userReducer,
    wellReducer
});

export default createStore(reducer);
